export default __webpack_public_path__ + "static/barlow-v4-latin-regular-cd8189826899fc6b7bfe650ed5fb8373.woff";